import React, { useEffect, useState } from 'react';

import { Checkmark, Times } from '@/assets/images';

import './Switch.scss';

type CenterIconProps = {
	className?: string;
	width?: number | string;
	height?: number | string;
};

type Props = {
	className?: string;
	onChange?: (value: boolean | undefined) => void;
	value?: boolean | undefined;
	text?: string[];
	size?: string;
	variant?: string;
};

const Switch = ({
	className,
	onChange,
	value,
	text,
	size,
	variant
}: Props): JSX.Element => {
	const [state, setState] = useState(value);
	const handleChange = (newVal: boolean | undefined) => {
		if (onChange) {
			setState(newVal);
			onChange(newVal);
		}
	};

	useEffect(() => {
		if (value !== state) {
			setState(value);
		}
	}, [value]);

	const CenterIcon = ({
		className: cName,
		width,
		height
	}: CenterIconProps) => {
		if (variant === 'green') {
			return state ? (
				<Checkmark
					width={width}
					height={height}
					className={`${cName ?? ''}`}
				/>
			) : (
				<Times
					width={width}
					height={height}
					className={`${cName ?? ''}`}
				/>
			);
		}
		return state ? (
			<Checkmark
				width={width}
				height={height}
				className={`${cName ? `${cName} ` : ''}text-dark`}
			/>
		) : (
			<Times
				width={width}
				height={height}
				className={`${cName ? `${cName} ` : ''}text-dark`}
			/>
		);
	};

	const buttonPosition = () => {
		if (state === true) {
			return ' right-0';
		}

		if (state === false) {
			return ' left-0';
		}

		return ' left-1/2 transform -translate-x-1/2';
	};

	return (
		<span
			className={`inline-block leading-none switch${
				size ? ` switch-${size}` : ''
			}${variant ? ` switch-${variant}` : ''}${
				state !== undefined && state !== null ? 'switch-checked' : ''
			}${state === false && variant === 'green' ? 'switch-red' : ''}${
				state !== undefined && state !== null ? 'switch-checked' : ''
			}${className ? ` ${className}` : ''}`}
		>
			<span className="inline-flex w-full cursor-pointer flex-row items-center rounded-3xl px-1 py-1">
				<span className="relative flex w-full items-center justify-between">
					<button
						className="flex flex-grow justify-center py-1"
						onClick={e => {
							e.stopPropagation();
							handleChange(false);
						}}
						type="button"
					>
						<span className="flex">
							{(text && (
								<span
									className={
										state === true || state === false
											? 'opacity-0'
											: ''
									}
								>
									{!state ? text[0] : text[1]}
								</span>
							)) ?? (
								<Times
									width={variant === 'green' ? 8 : undefined}
									height={variant === 'green' ? 8 : 14}
									className={
										state === true || state === false
											? 'opacity-0'
											: ''
									}
								/>
							)}
						</span>
					</button>
					<button
						onClick={e => {
							e.stopPropagation();
							handleChange(undefined);
						}}
						className={`switch-button-center inline-flex justify-center rounded-2xl items-center${
							state === undefined
								? ''
								: state === true
									? 'mr-2'
									: 'ml-2'
						}`}
						type="button"
					>
						{(text && (state === true || state === false) && (
							<span>
								{state === true ||
								state === undefined ||
								state === null
									? text[1]
									: text[0]}
							</span>
						)) ??
							((state === true || state === false) && (
								<CenterIcon
									width={variant === 'green' ? 8 : undefined}
									height={8}
								/>
							))}
					</button>
					<button
						className="flex flex-grow justify-center py-1"
						onClick={e => {
							e.stopPropagation();
							handleChange(true);
						}}
						type="button"
					>
						<span className="flex">
							{(text && (
								<span
									className={
										state === true || state === false
											? 'opacity-0'
											: ''
									}
								>
									{state === true ||
									state === undefined ||
									state === null
										? text[1]
										: text[0]}
								</span>
							)) ?? (
								<Checkmark
									width={variant === 'green' ? 8 : undefined}
									className={
										state === true || state === false
											? 'opacity-0'
											: ''
									}
								/>
							)}
						</span>
					</button>
					<button
						onClick={e => {
							e.stopPropagation();
							handleChange(undefined);
						}}
						className={`switch-button rounded-2xl absolute${buttonPosition()}`}
						type="button"
					/>
				</span>
			</span>
		</span>
	);
};

export default Switch;
